@if (content) {
  <div class="row" [class.reverse]="content.alignment == 'reversed'">
    <div class="col-12 col-md-6 first">
      @if (content.picture_tag_info) {
        <wagtail-page-element-image
          [image]="content.picture_tag_info"
          [width]="1100"
        ></wagtail-page-element-image>
      }
    </div>
    <div class="col-12 col-md-6 second">
      <div class="heading" [innerHTML]="content.title | breakAtSpace"></div>
      <div class="text"><p>{{ content.text }}</p></div>
      <div class="button">
        @if (buttonDefinition) {
          <wagtail-page-element-button
            [definition]="buttonDefinition"
          ></wagtail-page-element-button>
        }
      </div>
    </div>
  </div>
}
